import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrl: './forbidden.component.scss',
    standalone: true,
    imports: [TranslateModule]
})
export class ForbiddenComponent {

}
